import React, { useState, useRef  } from "react";
import AsyncSelect from "react-select/async";
// import DatePicker from "react-horizontal-datepicker";
import { useForm } from "react-hook-form";
import AppointmentStep6 from "./Step6";
import PatientInfo from "./PatientInfo";
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from "react-redux";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { insurance } from "../../redux/actions/appointmentActions";

function AppointmentStep5() {

  let AccessToken = localStorage.getItem("AccessToken");
  let NodeServerHost = process.env.REACT_APP_API_URL;
  let CareCode = localStorage.getItem("CareCode");
  let OperatingId = process.env.REACT_APP_OperatingId;
  let orgId = localStorage.getItem("orgId");

  const [showStepSix, setShowStepFive] = useState(false);

  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const [selectedValue, setSelectedValue] = useState(null);

  const loadLocationOptions = async (inputValue) => {
    return await fetch(NodeServerHost + `/Location/List?name=${inputValue}`, {
      headers: {
        OrganizationId: orgId,
        CareCode: CareCode,
        OperatingId: OperatingId,
        //Authorization: "Bearer " + AccessToken,
        "Content-Type": "application/json",
      },
    }).then((res) =>
      //console.log(res.json())
      res.json()
    );
  };

  const insuranceData = useSelector((state) => state.insurance.data)
  console.log(insuranceData);

  const dispatch = useDispatch();

  const handleLocationChange = (value) => {
    setSelectedValue(value);
  };

  const onSubmit = (data) => {
    setShowStepFive((value) => !value);
  };

  const onSubmitInsurance = (data) => {
    dispatch(insurance(data))
    setShowCoverageModal(false)
    reset();
  };

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const [showCoverageModal, setShowCoverageModal] = useState(false);

  const handleClose = () => setShowCoverageModal(false);
  const handleShow = () => setShowCoverageModal(true);
  
  // const dataa = [
  //   {test:"test3242"},
  //   {test:"24423"}
  // ]

  const insuranceList = insuranceData.map((insurance) =>
    //console.log(insurance)
    <li>
      <p className="mb-0">XYZ Insurance Company</p>
      <span className="text-secondary">ID: {insurance.insuranceType}</span>
    </li>
  )
  //console.log(insuranceList.length);

  const popoverFocus = (
    <Popover id="popover-trigger-focus" title="Popover bottom">
      <div className="p-2">
      <ul className="list-unstyled">
        {insuranceList.length > 0 && 
          <p>{insuranceList}</p>
        }
        {insuranceList.length === 0 && 
          <p>No insurance added</p>
        }
      </ul>
      <Button className="btn btn-sm" onClick={handleShow}>+ Add Insurance</Button>
      </div>
    </Popover>
  );
  
  if (showStepSix === false) {
    return (
      <div className="row justify-content-md-center">

    
        <div className="appointmentBackground"></div>
        <div className="col col-lg-5">
          <h3 className="mt-5 mb-3">Insurance</h3>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card pb-3 p-3 boxviewtransperant">
              <PatientInfo></PatientInfo>
              <div className="card-body">
                <div className="form-group">
                  <label className="fw-bold form-label">
                    Referring Physician
                  </label>
                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    value={selectedValue}
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.id}
                    loadOptions={loadLocationOptions}
                    onChange={handleLocationChange}
                    placeholder="Select physician"
                    name="appointmentLocation"
                    isMulti
                  />
                  {errors.appointmentLocation && (
                    <span className="text-danger">
                      This field is required
                    </span>
                  )}
                </div>
                <div className="row mt-3 mb-3">
                  <div className="col-md-6" ref={ref}>
                  
                    <OverlayTrigger trigger="focus" placement="bottom" overlay={popoverFocus}>
                      <Button className="btn btn-secondary btn-block" style={{ width: "100%" }}>I have Insurance</Button>
                    </OverlayTrigger>
                    
                  </div>
                  
                  <div className="col-md-6">
                    <button
                      className="btn btn-secondary btn-block"
                      style={{ width: "100%" }}
                    >
                      I don't have Insurance
                    </button>
                    
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label className="fw-bold form-label">
                    Message
                  </label>
                  <textarea className="form-control form-control-sm" placeholder="Type your message"></textarea>
                </div>
                <div className="form-group">
                  <label className="fw-bold form-label">
                    Supporting Documents
                  </label>
                  <br></br>
                  <div className="btn-group" role="group" aria-label="Basic example">
                    <input type="radio" className="btn-check" name="options-outlined" id="order-btn" autocomplete="off"></input>
                    <label className="btn btn-sm btn-outline-secondary attachments" for="order-btn">Order</label>

                    <input type="radio" className="btn-check" name="options-outlined" id="identification-btn" autocomplete="off"></input>
                    <label className="btn btn-sm btn-outline-secondary attachments" for="identification-btn">Identification</label>

                    <input type="radio" className="btn-check" name="options-outlined" id="other-btn" autocomplete="off"></input>
                    <label className="btn btn-sm btn-outline-secondary attachments" for="other-btn">Other</label>
                  </div>
                  <div className="mb-3 mt-3">
                    <input className="form-control form-control-sm form-control-sm" type="file" id="formFile"></input>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <button
                  className="btn btn-secondary btn-block"
                  style={{ width: "100%" }}
                >
                  Continue
                </button>
              </div>
            </div>
          </form>
        </div>
        <div>
        <Modal show={showCoverageModal} size="lg" onHide={handleClose}>
          <form onSubmit={handleSubmit(onSubmitInsurance)}>
            <Modal.Header closeButton>
              <Modal.Title>Add Insurance</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="row">
                <div className="col-md-4">
                    <div className="form-group">
                        <span className="text-danger me-1">*</span>
                        <label className="fw-bold form-label">Policy Holder</label>
                        <input className="form-control form-control-sm" name="policyHolder" id="policyHolder" defaultValue="" placeholder="Enter policy holder name"
                        {...register("policyHolder", { required: true })}></input>
                        {errors.policyHolder && (
                          <span className="text-danger">
                            This field is required
                          </span>
                        )}
                    </div>
                </div>
                <div className="form-group col-md-4 d-none">
                    <span className="text-danger me-1">*</span>
                    <label className="fw-bold form-label">Beneficiary Name</label>
                    <input type="text" className="form-control form-control-sm" id="beneficiary" name="beneficiary" placeholder="Enter beneficiary name" defaultValue=""
                    {...register("beneficiary", { required: false })}></input>
                    {errors.beneficiary && (
                      <span className="text-danger">
                        This field is required
                      </span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <span className="text-danger me-1">*</span>
                    <label className="fw-bold form-label">Relationship</label>
                    <select className="form-select form-select-sm" id="billingRelationship" name="billingRelationship" defaultValue=""
                    {...register("billingRelationship", { required: true })}>
                        <option value="">Select Relationship</option>
                        <option value="child">Child</option>
                        <option value="parent">Parent</option>
                        <option value="spouse">Spouse</option>
                        <option value="common">Common Law Spouse</option>
                        <option value="other">Other</option>
                        <option value="self">Self</option>
                        <option value="injured">Injured Party</option>
                    </select>
                    {errors.billingRelationship && (
                      <span className="text-danger">
                        This field is required
                      </span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <span className="text-danger me-1">*</span>
                    <label className="fw-bold form-label">Status</label>
                    <select className="form-select form-select-sm" id="status" name="status" autocomplete="off" defaultValue=""
                    {...register("status", { required: true })}>
                        <option value="">Select status</option>
                        <option value="active">Active</option>
                        <option value="cancelled">Cancelled</option>
                        <option value="darft">Draft</option>
                        <option value="entered-in-error">Entered-in-error</option>
                    </select>
                    {errors.status && (
                      <span className="text-danger">
                        This field is required
                      </span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <span className="text-danger me-1">*</span>
                    <label className="fw-bold form-label">Insurance Type</label>
                    <select className="form-select form-select-sm" id="insuranceType" name="insuranceType" autocomplete="off" defaultValue=""
                    {...register("insuranceType", { required: true })}>
                        <option value="">Select status</option>
                        <option value="pay">Pay</option>
                        <option value="EHCPOL">extended healthcare</option>
                        <option value="HSAPOL">health spending account</option>
                        <option value="AUTOPOL">automobile</option>
                        <option value="COL">collision coverage policy</option>
                        <option value="UNINSMOT">uninsured motorist policy</option>
                        <option value="PUBLICPOL">public healthcare</option>
                        <option value="DENTPRG">dental program</option>
                        <option value="DISEASEPRG">public health program</option>
                        <option value="CANPRG">women's cancer detection program</option>
                        <option value="ENDRENAL">end renal program</option>
                        <option value="HIVAIDS">HIV-AIDS program</option>
                        <option value="MANDPOL">mandatory health program</option>
                        <option value="MENTPRG">mental health program</option>
                        <option value="SAFNET">safety net clinic program</option>
                        <option value="SUBPRG">substance use program</option>
                    </select>
                    {errors.insuranceType && (
                      <span className="text-danger">
                        This field is required
                      </span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <span className="text-danger me-1">*</span>
                    <label className="fw-bold form-label">Payer</label>
                    <select className="form-select form-select-sm" id="payer" name="payer"
                    {...register("payer", { required: true })}>
                        <option value="">Select payer</option>
                        <option value="Demo1">Demo1</option>
                        <option value="Demo2">Demo2</option>
                    </select>
                    {errors.payer && (
                      <span className="text-danger">
                        This field is required
                      </span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <label className="fw-bold form-label">Subscriber</label>
                    <input type="text" className="form-control form-control-sm" id="subscriber" name="subscriber" placeholder="Enter subscriber"
                    {...register("subscriber", { required: false })}></input>
                </div>
                <div className="form-group col-md-4">
                    <label className="fw-bold form-label">Subscriber Id</label>
                    <input type="text" className="form-control form-control-sm" id="subscriberId" name="subscriberId" placeholder="Enter subscriber"
                    {...register("subscriberId", { required: false })}></input>
                </div>
                <div className="form-group col-md-4">
                    <label className="fw-bold form-label">Period Start</label>
                    <input type="date" className="form-control form-control-sm calender" id="startPeriod" name="startPeriod" placeholder="Select start date" autocomplete="off" formateddate="2021-01-07"
                    {...register("startPeriod", { required: false })}></input>
                    {/* <div className="calendar-icn input-group-addon datetimepicker-addon"><i className="fa fa-calendar"></i></div> */}
                </div>
                <div className="form-group col-md-4">
                    <label className="fw-bold form-label">Period End</label>
                    <input type="date" className="form-control form-control-sm calender" id="endPeriod" name="endPeriod" placeholder="Select end date" autocomplete="off" formateddate="2021-01-07"
                    {...register("endPeriod", { required: false })}></input>
                    {/* <div className="calendar-icn input-group-addon datetimepicker-addon"><i className="fa fa-calendar"></i></div> */}
                </div>
                <div className="form-group col-md-4">
                    <label className="fw-bold form-label">Insurer Network</label>
                    <input type="text" className="form-control form-control-sm" id="insurerNetwork" name="insurerNetwork" placeholder="Enter insurer network"
                    {...register("insurerNetwork", { required: false })}></input>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-start">
              {/* <Button className="btn btn-sm" variant="primary" onClick={handleClose}> */}
              <button className="btn btn-secondary btn-block" style={{ width: "100%" }}>Continue</button>
            </Modal.Footer>
          </form>
        </Modal>
        </div>
      </div>
    );
  } else {
    return <AppointmentStep6 />;
  }
}

export default AppointmentStep5;
